/** @jsx jsx */
import { jsx } from '@emotion/core'
import { IconImage } from 'bold-ui'
import { ReactComponent as IconSaudeMulher } from 'images/acompanhamento/icon-saude-mulher.svg'
import { Accordion } from 'react-accessible-accordion'

import { ListaTematicaInformacaoAccordionItem } from './ListaTematicaInformacaoAccordionItem'

const ORIGEM_CIDADAO_CDS_RAS_TERRITORIO_TERCEIRO = 'Cidadão, CDS, RAS PEC, e-SUS Território, Sistema 3º'
const ORIGEM_SOAP = 'SOAP do atendimento'
const ORIGEM_TERRITORIO_CDS_RAS_TERCEIRO = 'e-SUS Território, CDS, RAS PEC, Sistema 3º'
const ORIGEM_VACINACAO_TERRITORIO_CDS_RAS_TERCEIRO = 'Vacinação, e-SUS Vacinação, CDS, RAS PEC, Sistema 3º'
const ORIGEM_SOAP_RAS_TERCEIRO = 'SOAP do atendimento, RAS PEC e Sistema 3º'
const ORIGEM_ATIVIDADE_COLETIVA = 'Atividade coletiva'
const ORIGEM_CIDADAO_CDS_RAS_APP_TERCEIRO = 'Cidadão, CDS, RAS PEC, App Território, Sistema 3º'
const ORIGEM_IMPORTACAO_BOLSA_FAMILIA = 'Importação do Bolsa Família'

export type OrigemDados = { tipoRegistro: string; origem: string }

type ListaTematicaInfo = {
  icone?: IconImage
  titulo: string
  conteudo: OrigemDados[]
}

const ListaTematicaOrigemDados: ListaTematicaInfo[] = [
  {
    icone: 'userFilled',
    titulo: 'Dados gerais',
    conteudo: [
      { tipoRegistro: 'Nome', origem: ORIGEM_CIDADAO_CDS_RAS_TERRITORIO_TERCEIRO },
      { tipoRegistro: 'CPF', origem: ORIGEM_CIDADAO_CDS_RAS_TERRITORIO_TERCEIRO },
      { tipoRegistro: 'CNS', origem: ORIGEM_CIDADAO_CDS_RAS_TERRITORIO_TERCEIRO },
      { tipoRegistro: 'Idade', origem: ORIGEM_CIDADAO_CDS_RAS_TERRITORIO_TERCEIRO },
      { tipoRegistro: 'Microárea', origem: ORIGEM_CIDADAO_CDS_RAS_TERRITORIO_TERCEIRO },
      { tipoRegistro: 'Último atendimento - Médico', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Último atendimento - Enfermagem', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Último atendimento - Odontológico', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Último atendimento - Visita domiciliar', origem: ORIGEM_TERRITORIO_CDS_RAS_TERCEIRO },
      { tipoRegistro: 'Última medição - Peso/altura', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Última medição - P.A.', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Beneficiário do programa Bolsa Família', origem: ORIGEM_IMPORTACAO_BOLSA_FAMILIA },
      { tipoRegistro: 'Vigência do programa Bolsa Família', origem: ORIGEM_IMPORTACAO_BOLSA_FAMILIA },
      { tipoRegistro: 'Telefone', origem: ORIGEM_CIDADAO_CDS_RAS_TERRITORIO_TERCEIRO },
      { tipoRegistro: 'Endereço', origem: ORIGEM_CIDADAO_CDS_RAS_TERRITORIO_TERCEIRO },
      { tipoRegistro: 'Data de nascimento', origem: ORIGEM_CIDADAO_CDS_RAS_TERRITORIO_TERCEIRO },
      { tipoRegistro: 'Sexo', origem: ORIGEM_CIDADAO_CDS_RAS_TERRITORIO_TERCEIRO },
      { tipoRegistro: 'Identidade de gênero', origem: ORIGEM_CIDADAO_CDS_RAS_TERRITORIO_TERCEIRO },
      { tipoRegistro: 'Raça/cor', origem: ORIGEM_CIDADAO_CDS_RAS_TERRITORIO_TERCEIRO },
    ],
  },
  {
    icone: 'pregnant',
    titulo: 'Gestação e puerpério',
    conteudo: [
      { tipoRegistro: 'Risco gestacional', origem: ORIGEM_SOAP },
      { tipoRegistro: 'DUM', origem: ORIGEM_SOAP },
      { tipoRegistro: 'IG (DUM)', origem: ORIGEM_SOAP },
      { tipoRegistro: 'DPP (DUM)', origem: ORIGEM_SOAP },
      { tipoRegistro: 'IG (ecografia obstétrica)', origem: ORIGEM_SOAP },
      { tipoRegistro: 'DPP (ecografia obstétrica)', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Consultas de pré-natal', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Consultas de pré-natal até 23 semanas', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Última consulta de pré-natal', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Registros de altura uterina no pré-natal', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Registros de pressão arterial no pré-natal', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Registros de peso e altura simultâneos no pré-natal', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Exame de HIV (1º Trimestre)', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Exame de Sífilis (1º Trimestre)', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Exame de Hepatite B (1º Trimestre)', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Exame de Hepatite C (1º Trimestre)', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Exame de HIV (3º Trimestre)', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Exame de Sífilis (3º Trimestre)', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Visitas domiciliares no pré-natal', origem: ORIGEM_TERRITORIO_CDS_RAS_TERCEIRO },
      { tipoRegistro: 'Visitas domiciliares no puerpério', origem: ORIGEM_TERRITORIO_CDS_RAS_TERCEIRO },
      { tipoRegistro: 'Consultas no puerpério', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Última consulta de puerpério', origem: ORIGEM_SOAP },
      { tipoRegistro: 'dTpa', origem: ORIGEM_VACINACAO_TERRITORIO_CDS_RAS_TERCEIRO },
    ],
  },
  {
    icone: 'sixtyPlus',
    titulo: 'Pessoa idosa',
    conteudo: [
      { tipoRegistro: 'IVCF-20: Risco', origem: ORIGEM_SOAP_RAS_TERCEIRO },
      { tipoRegistro: 'IVCF-20: Data do registro', origem: ORIGEM_SOAP_RAS_TERCEIRO },
      { tipoRegistro: 'IVCF-20: Dimensões alteradas', origem: ORIGEM_SOAP_RAS_TERCEIRO },
      { tipoRegistro: 'Registros de peso e altura simultâneos nos últimos 12 meses', origem: ORIGEM_SOAP },
      {
        tipoRegistro: 'Quantidade de Visitas domiciliares dos últimos 36 meses',
        origem: ORIGEM_TERRITORIO_CDS_RAS_TERCEIRO,
      },
      {
        tipoRegistro: 'Data das duas últimas Visitas domiciliares últimos 36 meses',
        origem: ORIGEM_TERRITORIO_CDS_RAS_TERCEIRO,
      },
      { tipoRegistro: 'Influenza (últimos 12 meses)', origem: ORIGEM_VACINACAO_TERRITORIO_CDS_RAS_TERCEIRO },
    ],
  },
  {
    icone: 'teddyBear',
    titulo: 'Desenvolvimento infantil',
    conteudo: [
      { tipoRegistro: 'Primeira consulta', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Idade na primeira consulta', origem: ORIGEM_CIDADAO_CDS_RAS_APP_TERCEIRO },
      { tipoRegistro: 'Consultas até 24 meses (quantidade)', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Registro de peso e altura simultâneas até 24 meses', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Visitas domiciliares até 24 meses (quantidade)', origem: ORIGEM_TERRITORIO_CDS_RAS_TERCEIRO },
      { tipoRegistro: 'Primeira visita', origem: ORIGEM_TERRITORIO_CDS_RAS_TERCEIRO },
      { tipoRegistro: 'Segunda visita', origem: ORIGEM_TERRITORIO_CDS_RAS_TERCEIRO },
      {
        tipoRegistro: 'Difteria, Tétano, Pertusis, Hepatite B, Haemophilus Influenza B',
        origem: ORIGEM_VACINACAO_TERRITORIO_CDS_RAS_TERCEIRO,
      },
      { tipoRegistro: 'Poliomielite', origem: ORIGEM_VACINACAO_TERRITORIO_CDS_RAS_TERCEIRO },
      { tipoRegistro: 'Sarampo, Caxumba, Rubéola', origem: ORIGEM_VACINACAO_TERRITORIO_CDS_RAS_TERCEIRO },
      { tipoRegistro: 'Pneumocócica', origem: ORIGEM_VACINACAO_TERRITORIO_CDS_RAS_TERCEIRO },
      { tipoRegistro: 'Última suplementação', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Idade na última suplementação', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Doses de 6 a 11 meses', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Doses de 12 a 23 meses', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Doses de 24 a 59 meses', origem: ORIGEM_SOAP },
    ],
  },
  {
    icone: 'glucometer',
    titulo: 'Diabetes',
    conteudo: [
      { tipoRegistro: 'Consultas (36 meses)', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Última consulta', origem: ORIGEM_SOAP },

      { tipoRegistro: 'Última medição da hemoglobina glicada', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Data da última avaliação da hemoglobina glicada', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Data da última solicitação da hemoglobina glicada', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Data da última avaliação dos pés', origem: ORIGEM_SOAP },
      {
        tipoRegistro: 'Quantidade de visitas domiciliares dos últimos 36 meses',
        origem: ORIGEM_TERRITORIO_CDS_RAS_TERCEIRO,
      },
      {
        tipoRegistro: 'Data das duas últimas visitas domiciliares últimos 36 meses',
        origem: ORIGEM_TERRITORIO_CDS_RAS_TERCEIRO,
      },
    ],
  },
  {
    icone: 'bloodPressureFilled',
    titulo: 'Hipertensão',
    conteudo: [
      { tipoRegistro: 'Consultas (36 meses)', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Última consulta', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Medições de P.A. (36 meses)', origem: ORIGEM_SOAP },

      {
        tipoRegistro: 'Quantidade de visitas domiciliares dos últimos 36 meses',
        origem: ORIGEM_TERRITORIO_CDS_RAS_TERCEIRO,
      },
      {
        tipoRegistro: 'Data das duas últimas visitas domiciliares últimos 36 meses',
        origem: ORIGEM_TERRITORIO_CDS_RAS_TERCEIRO,
      },
    ],
  },
  {
    icone: 'toothFilled',
    titulo: 'Saúde bucal',
    conteudo: [
      { tipoRegistro: 'Primeira consulta', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Tratamento odontológico concluído', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Último tratamento restaurador atraumático', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Registro de escovação supervisionada em atividade coletiva', origem: ORIGEM_ATIVIDADE_COLETIVA },
      { tipoRegistro: 'Exodontias de dentes realizadas (permanentes)', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Procedimentos odontológicos preventivos', origem: ORIGEM_SOAP },
    ],
  },
  {
    icone: IconSaudeMulher,
    titulo: 'Saúde da mulher',
    conteudo: [
      { tipoRegistro: 'Última consulta de saúde sexual e reprodutiva', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Data da última avaliação de HIV', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Data da última avaliação de Sífilis', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Data da última avaliação de Hepatite B', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Data da última avaliação de Hepatite C', origem: ORIGEM_SOAP },
      {
        tipoRegistro: 'Data da última solicitação de exames de rastreio de câncer de colo de útero',
        origem: ORIGEM_SOAP,
      },
      {
        tipoRegistro: 'Data da última avaliação de exames de rastreio de câncer de colo de útero',
        origem: ORIGEM_SOAP,
      },
      { tipoRegistro: 'Data da última solicitação de exame de rastreio de câncer de mama', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Data da última realização de rastreio de câncer de mama', origem: ORIGEM_SOAP },
      { tipoRegistro: 'Data da última avaliação de rastreio de câncer de mama', origem: ORIGEM_SOAP },
      { tipoRegistro: 'HPV', origem: ORIGEM_VACINACAO_TERRITORIO_CDS_RAS_TERCEIRO },
    ],
  },
  {
    titulo: 'Definição da origem',
    conteudo: [
      {
        tipoRegistro: 'SOAP do atendimento',
        origem:
          'Registros efetuados na própria instalação, através do módulo de atendimentos acessado pela lista de atendimentos',
      },
      { tipoRegistro: 'e-SUS Território', origem: 'Registros efetuados pelo aplicativo e-SUS Território' },
      {
        tipoRegistro: 'CDS',
        origem: 'Registros efetuados na própria instalação, através dos módulos de coleta de dados simplificado',
      },
      {
        tipoRegistro: 'RAS PEC',
        origem: 'Registros efetuados em outras instalações do Prontuário Eletrônico e-SUS APS',
      },
      { tipoRegistro: 'Sistema 3º', origem: 'Registro importado de outros sistemas' },
      { tipoRegistro: 'Cidadão', origem: 'Registros efetuados no módulo Cidadão' },
      {
        tipoRegistro: 'Atividade Coletiva',
        origem: 'Registros efetuados pelo módulo de atividade em saúde da atividade coletiva',
      },
      {
        tipoRegistro: 'Vacinação',
        origem:
          'Registros de vacinação e transcrição de cadernetas realizadas pelo módulo de atendimento acessado pela lista de atendimentos',
      },
      { tipoRegistro: 'e-SUS Vacinação', origem: 'Registros efetuados pelo aplicativo e-SUS Vacinação' },
      { tipoRegistro: 'Importação do Bolsa Família', origem: 'Registro da importação do Bolsa Família' },
    ],
  },
]

export function ListaTematicaInformacaoAccordion() {
  return (
    <Accordion allowZeroExpanded allowMultipleExpanded>
      {ListaTematicaOrigemDados.map((dados, index) => (
        <ListaTematicaInformacaoAccordionItem
          title={dados.titulo}
          index={index}
          totalItems={ListaTematicaOrigemDados.length}
          icon={dados.icone}
          key={dados.titulo}
          conteudoLinha={dados.conteudo}
        />
      ))}
    </Accordion>
  )
}
